"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractChain = extractChain;
function extractChain({ chains, id, }) {
    return chains.find((chain) => chain.id === id);
}
//# sourceMappingURL=extractChain.js.map